<template>
  <div class="form addCard" v-loading="loading">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>
          <h4>{{ config.title }}</h4></span
        >
      </div>
      <div>
        <el-form ref="form" label-width="70px" label-position="left">
          <el-form-item :label="config['setp1'].title">
            <div class="input">
              <div>
                <h3>{{ config["setp1"].text }}</h3>
              </div>
            </div>
          </el-form-item>
          <template v-if="config['setp2']">
            <el-form-item :label="config['setp2'].title">
              <div class="input">
                <div>
                  <h3>{{ config["setp2"].text }}</h3>
                </div>
                <div>
                  <cc-uploader
                    :config="uploaderConf"
                    fType="file"
                    v-model="productFilePath"
                    :fFormatV2="config.fileType[1]"
                  />
                </div>
              </div>
            </el-form-item>
          </template>
          <template v-if="config['setp3']">
            <el-form-item :label="config['setp3'].title">
              <div class="input">
                <div>
                  <h3>{{ config["setp3"].text }}</h3>
                </div>
                <div>
                  <cc-uploader
                    :config="uploaderConf"
                    fType="file"
                    v-model="imageFilePath"
                    :fFormatV2="config.fileType[2]"
                    :maxFSize="200"
                  />
                </div>
              </div>
            </el-form-item>
          </template>
          <el-form-item>
            <el-button type="primary" @click="uploader">{{
              config["stepButton"]
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :title="language('batchEditCard.tips')"
      :visible.sync="dialog"
      width="50%"
      append-to-body
    >
      <div v-for="(items, index) in err">
        <div  class="title_tips" v-if="items.code!=200">{{items.message}}</div>

        <div class="err_tips" v-if="items.code==200" v-for="(item, index) in items.fieldValidResults">
          <div>RowNum :{{ items.rowNum }}</div>
          <div>{{ item.message }}</div>
          <div>{{ item.fildName }}</div>
          <el-divider></el-divider>
        </div>
      </div>

      <div class="change_shop_button_wrap">
        <el-button type="primary" @click="dialog = false">{{
          language("batchEditCard.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import uploadUtils from "../utils/ossUtils";

export default {
  props: {
    config: Object,
  },
  data() {
    return {
      uploaderConf: uploadUtils.configPublish,
      imageFilePath: "",
      productFilePath: "",
      loading: false,
      err: [],
      dialog: false,
    };
  },
  methods: {
    uploader() {
      if (this.productFilePath == "") {
        this.$message.error(this.language("batchEditCard.productFilePathErr"));
        return false;
      }

      this.$confirm(
        this.language("batchEditCard.confirmText"),
        this.language("batchEditCard.tips"),
        {
          confirmButtonText: this.language("batchEditCard.confirm"),
          cancelButtonText: this.language("batchEditCard.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let data = {
            productFilePath: this.productFilePath,
            imageFilePath: this.imageFilePath,
            opType: 1,
          };
          for (const key in this.config.form) {
            if (this.config.form[key]) {
              data[key] = this.config.form[key];
            }
          }
          //提交
          this.loading = true;
          this.ccRequest
            .do(this.config.uploaderUrl, data)
            .then((res) => {
              this.loading = false;
              if (res.code == 500) {
                this.dialog = true;
                this.err = res.data.validResultList;
                this.$message.error(
                  this.language("batchAddCard.uploadFailedTips")
                );
              } else {
                this.$message({
                  message: this.language("batchAddCard.success"),
                  type: "success",
                });
                this.$emit("success", true);
                this.imageFilePath = "";
                this.productFilePath = "";
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted(){
      this.uploaderConf=uploadUtils.configPublishV2( "/perm/sisProduct/")

  }
};
</script>
<style scoped>
.title_tips {
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.addCard {
  .upload-btnV2 .upload-demo {
    margin-top: -21px !important;
  }
}
</style>